export default __webpack_public_path__ + "static/media/clipboard.138779c9.svg";